import CompleteDemographicsModal from './CompleteDemographicsModal';

export default CompleteDemographicsModal;
